import { type ReactElement } from 'react'
import { isRoleId, isTeamId, isUserId, type PermissionEntityId } from '@terros/common'
import { useNavigate } from '@tanstack/react-router'
import { usePermissions } from '@front/model'
import { NotReady } from '../NotReady'
import { TButton } from '../buttons'
import { EntityPermissions } from './EntityPermissions'

type Props = {
  entityId: PermissionEntityId
  readOnly?: boolean
  stickyToolbar?: boolean
}

export const PermissionContent = ({ entityId, readOnly, stickyToolbar }: Props): ReactElement => {
  const navigate = useNavigate()
  const { data: permissionList, isLoading, error, refetch, isFetching } = usePermissions(entityId)
  const canCompare = isUserId(entityId) || isTeamId(entityId) || isRoleId(entityId)

  if (isLoading || !permissionList || error) return <NotReady error={error} isLoading={isLoading} />

  return (
    <EntityPermissions
      entityId={entityId}
      isFetching={isFetching}
      permissionList={permissionList}
      readOnly={readOnly}
      refetch={refetch}
      stickyToolbar={stickyToolbar}
      toolbarActions={
        canCompare && (
          <TButton
            icon='compare_arrows'
            variant='secondary'
            onClick={() => navigate({ to: '/settings/permissions/compare', search: { entities: [entityId] } })}
          >
            Compare
          </TButton>
        )
      }
    />
  )
}
